export { default } from './CurrencyFormat';
